import { render, staticRenderFns } from "./SSeparator.vue?vue&type=template&id=25f3fad7&scoped=true&"
import script from "./SSeparator.vue?vue&type=script&lang=js&"
export * from "./SSeparator.vue?vue&type=script&lang=js&"
import style0 from "./SSeparator.vue?vue&type=style&index=0&id=25f3fad7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3fad7",
  null
  
)

export default component.exports